import { useCallback, useState } from 'react';

import { useDatabaseContext } from '../screens/DatabaseContextProvider';
import { getImportMappings } from '../services/api';

export function useImportMappings() {
  const {
    data: { importMappings },
    updateContext,
  } = useDatabaseContext();
  const [isLoading, setIsLoading] = useState(true);

  const setImportMappings = updateContext('importMappings');

  const fetchNewMappings = useCallback(
    async (timeEntriesIds: string[]) => {
      const missingMappings = timeEntriesIds.filter(
        (id) => importMappings[Number(id)] === undefined
      );
      if (missingMappings.length) {
        setIsLoading(true);
        const newMappings = await getImportMappings(missingMappings);
        setImportMappings((prev) => ({
          ...prev,
          ...newMappings,
        }));
      }
      setIsLoading(false);
    },
    [setImportMappings, importMappings]
  );

  return { importMappings, isLoading, fetchNewMappings };
}
